import React from 'react';
import PropTypes from 'prop-types';
import EngineScoringClassificationFinancialIndicatorListComponent from './EngineScoringClassificationFinancialIndicatorListComponent';

const EngineScoringClassificationFinancialIndicatorListContainer = ({
  engineScoringId,
  financialIndicators,
  engineClassificationIndex,
  isReadOnly,
  validation,
  dispatch,
  scoringFinancialIndicatorOptions
}) => {
  return (
    <EngineScoringClassificationFinancialIndicatorListComponent
      engineScoringId={engineScoringId}
      financialIndicators={financialIndicators}
      engineClassificationIndex={engineClassificationIndex}
      isReadOnly={isReadOnly}
      scoringFinancialIndicatorOptions={scoringFinancialIndicatorOptions}
      dispatch={dispatch}
      validation={validation}
    />
  );
};

EngineScoringClassificationFinancialIndicatorListContainer.propTypes = {
  engineScoringId: PropTypes.number.isRequired,
  financialIndicators: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  engineClassificationIndex: PropTypes.number.isRequired,
  scoringFinancialIndicatorOptions: PropTypes.array.isRequired
};

export default EngineScoringClassificationFinancialIndicatorListContainer;
